<template>
  <LayoutContainer>
    <template v-if="isSubmitted">
      <p class="py-20">
        {{ $t('dbc-text-report-sent') }}<br />{{ $t('dbc-text-thanks') }}.
      </p>
    </template>
    <template v-else>
      <FormKit
        type="form"
        id="rampage"
        name="rampage-form"
        :actions="false"
        @submit="submit"
        #default="{ state: { valid } }"
        form-class="max-w-150 mx-auto"
      >
        <FormKit
          type="tel"
          name="bikeNumber"
          :label="$t('dbc-label-bike-number')"
          :placeholder="$t('dbc-label-bike-number')"
          maxlength="5"
          validation="required|number|length:4,5"
          validation-visibility="blur"
          :validation-messages="{
            required: $t('dbc-form-lost-and-found-input-bike-number-error'),
            number: $t('dbc-form-lost-and-found-input-bike-number-error'),
            length: $t('dbc-form-lost-and-found-input-bike-number-error'),
          }"
        />
        <FormKit
          type="select"
          id="type"
          name="type"
          :label="$t('dbc-label-category')"
          :options="damageTypes"
        />
        <FormKit
          type="textarea"
          id="comment"
          name="comment"
          :label="$t('dbc-label-description')"
          rows="10"
          :placeholder="$t('dbc-label-description')"
          maxlength="250"
          validation="required|length:20,250"
          validation-visibility="blur"
          :validation-messages="{
            length: $t(
              'dbc-form-lost-and-found-textarea-location-description-error'
            ),
          }"
        />
        <FormKit type="hidden" name="reporter" :value="reporter" />
        <FormKit type="hidden" name="client" :value="client" />
        <FormKit type="hidden" name="language" :value="language" />
        <FormKit
          type="submit"
          :label="$t('dbc-button-send')"
          :prefix-icon="valid && !isLoading ? 'submitArrow' : ''"
          input-class="!min-w-[128px] !max-w-[160px]"
          :disabled="!valid || isLoading"
          :loading="isLoading"
        />
      </FormKit>
    </template>
  </LayoutContainer>
</template>

<script setup lang="ts">
import { type FormKitNode } from '@formkit/core'

const runtimeConfig = useRuntimeConfig()

const client = runtimeConfig.public.client
const baseURL = runtimeConfig.public.apiBaseURL
const language = 'de'
const reporter = 'Employee'

const { setLocale } = useI18n()
setLocale(language)

const isLoading = ref(false)
const isSubmitted = ref(false)

type DamageType = {
  id: string
  description: string
}

const { data } = await useFetch<{ data: Array<DamageType> }>(
  '/bikes/damageTypes',
  {
    baseURL,
    query: {
      language,
      client,
    },
  }
)

const damageTypes = computed(() =>
  data.value?.data.map((type) => ({
    label: type.description,
    value: type.id,
  }))
)

async function submit(
  data: FormDataLostAndFound,
  node: FormKitNode
): Promise<void> {
  isLoading.value = true

  await $fetch('bikes/damageReport', {
    baseURL,
    method: 'POST',
    body: data,
    async onResponseError({ response }) {
      node.setErrors(
        response._data.messages.map((m: { message: string }) => m.message)
      )
      isLoading.value = false
      isSubmitted.value = false
    },
  })
    .then(() => (isSubmitted.value = true))
    // needed to enable input fields again
    .catch(() => null)
    .finally(() => (isLoading.value = false))
}
</script>
